import { useRoute } from 'vue-router'
import { APISettings } from '../api/config';

export async function getUser() {
    const route = useRoute();
    const response = await fetch(APISettings.baseURL+'/accounts?'+route.params.i+'&'+route.params.m+'&'+route.params.p+'&'+route.params.c, {
        method: 'GET',
        headers: APISettings.headers
    });
    return await response.json();
}

export async function postData(dataToSend) {
    const response = await fetch(APISettings.baseURL+'/contacts', {
        method: 'POST',
        headers: APISettings.headers,
        body: JSON.stringify(dataToSend)
    })
    return await response.json();
}

export async function getCodeClientWithContexte(email, contexte) {
    const response = await fetch(APISettings.baseURL + '/code-client/contexte?contexte=' + encodeURIComponent(contexte) + '&email=' + encodeURIComponent(email), {
        method: 'GET',
        headers: APISettings.headers
    })
    return await response.json()
}

export async function getInfoClientWithCodeClient(codeClient) {
    const response = await fetch(APISettings.baseURL + '/accounts/' + codeClient, {
        method: 'GET',
        headers: APISettings.headers
    })
    return await response.json()
}

export async function postFormulaire(dataForm) {
    const response = await fetch(APISettings.baseURL + '/accounts/formulaire', {
        method: 'POST',
        headers: APISettings.headers,
        body: JSON.stringify(dataForm) 
    })

    if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        throw new Error(errorBody.message || 'Erreur interne du serveur');
    }
    return await response.json();
}

export async function postOptinFormulaire(dataOptin) {
    const response = await fetch(APISettings.baseURL + '/contacts/formulaire', {
        method: 'POST',
        headers: APISettings.headers,
        body: JSON.stringify(dataOptin)
    })
    return await response.json();
}